import { Link } from 'react-router-dom';

import { LegalPlaceholder, LegalSection } from '@/components/LegalPlaceholder';

/**
 * Preguntas frecuentes — **contenido provisorio**.
 *
 * ⚠️ Sólo responde lo que hoy se puede afirmar **con certeza** mirando el
 * producto. Lo que depende de decisiones abiertas —plazos de devolución,
 * medios de pago definitivos— **no se contesta**: una respuesta inventada en un
 * lugar donde el fan viene a informarse es peor que la ausencia de respuesta.
 */
export function FaqPage(): JSX.Element {
  return (
    <LegalPlaceholder
      title="Preguntas frecuentes"
      notice={
        <>
          Estamos armando esta sección. Abajo están las respuestas que ya podemos dar; si tu duda no
          está, escribinos a{' '}
          <a href="mailto:soporte@miboleta.co" className="underline">
            soporte@miboleta.co
          </a>
          .
        </>
      }
    >
      <LegalSection title="¿Cómo recibo mi boleta?">
        Al confirmar la compra, la boleta queda en tu cuenta con su código. La encontrás en “Mis
        Tickets”, y no necesitás imprimir nada: se valida desde el teléfono.
      </LegalSection>

      <LegalSection title="¿Necesito una cuenta para comprar?">
        Sí. La boleta se emite a nombre de quien figura en la cuenta, así que hace falta registrarse
        antes de pagar.
      </LegalSection>

      <LegalSection title="¿Por qué me piden el documento?">
        Para verificar tu identidad al ingresar al evento y para los soportes de la compra. Es el
        mismo documento que tendrás que presentar en la puerta.
      </LegalSection>

      <LegalSection title="¿Qué es una fila virtual?">
        En las promos con alta demanda te asignamos un turno para que la compra sea ordenada.
        Mientras esperás no perdés el lugar, y cuando llega tu turno tenés un tiempo para completar
        el pago.
      </LegalSection>

      <LegalSection title="¿Qué hacen con mis datos?">
        Está explicado en la{' '}
        <Link to="/privacidad" className="underline">
          política de privacidad
        </Link>
        .
      </LegalSection>
    </LegalPlaceholder>
  );
}
